<template>
  <footer class="footer">
    <div class="container-md row">
      <nav class="col-3 col-md-4 ml-md-4">
        <ul class="footer-menu">
          <!-- <li>
            <router-link :to="{ path: '/admin' }">Chami Ride</router-link>
          </li> -->
        </ul>
      </nav>
      <div class="copyright text-end col-6 col-md-3 ml-md-4 pl-md-3 justify-content-center align-content-center" >
  &copy; Desarrollado por <a class="newStyle" href="https://ticz.io" target="_blank">Ticz</a>.

  </div>
    </div>
  </footer>
</template>
<script>
export default {}

</script>
<style scoped>
.newStyle:hover {
  color: #651366!important;
  text-decoration: none !important; /* Elimina el subrayado */
}
.newStyle {
  color: orange !important;
  text-decoration: none !important;
}
</style>
